export const colors = {
    primary: "#e66101",
    reference: "#5e3c99",
    hover: "#008837"
}